import React, { useState } from 'react';
const faqs = [{
  q: '¿Para quién es?',
  a: 'Para kinesiólogos, fisioterapeutas, terapeutas ocupacionales, profes de educación física, coordinadores de centros de día y cuidadores que dan talleres a grupos de personas mayores.'
}, {
  q: '¿Para cuántas personas está pensado?',
  a: 'Para grupos de 4 a 10 personas. También se puede adaptar a sesiones con menos gente.'
}, {
  q: '¿Sirve si en el grupo hay personas en silla de ruedas?',
  a: 'Sí. Cada ficha trae una versión para hacer el ejercicio sentado.'
}, {
  q: '¿Qué materiales necesito?',
  a: 'Cosas simples: sillas firmes sin ruedas, una pelota blanda, pañuelos, tarjetas de colores, botellas plásticas y música. Cada tomo trae la lista completa por semana.'
}, {
  q: '¿Cómo lo recibo?',
  a: 'Apenas se confirma el pago, te llega por correo el acceso a los 2 tomos en PDF y a los 4 bonos. Los descargas y los usas las veces que quieras.'
}, {
  q: '¿Lo puedo imprimir?',
  a: 'Sí. Está diseñado en hoja A4 vertical, para imprimir a color o en blanco y negro. También lo puedes seguir desde la tablet.'
}, {
  q: '¿Reemplaza la indicación del médico o del profesional?',
  a: 'No. Es un material de apoyo para organizar las sesiones. Cada participante tiene que contar con la indicación de su médico para hacer actividad física, y quien guía la sesión adapta cada ejercicio a cada persona.'
}, {
  q: '¿Es un pago único?',
  a: 'Sí. Pagas una sola vez, sin suscripciones ni cobros mensuales.'
}, {
  q: '¿Puedo pagar desde mi país?',
  a: 'Sí, desde cualquier país. En Argentina, México, Colombia, Chile, Perú, Uruguay y España ves el precio en tu moneda; en el resto, en dólares. Pagas con los medios disponibles en tu país.'
}];
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);
  return <section className="w-full bg-[#0b3a2d] py-16 px-4" data-id="element-54" data-mp="tzm83et4vpi1">
      <div className="max-w-3xl mx-auto" data-id="element-55" data-mp="u28pe65ttjdg">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-10" data-id="element-56" data-mp="p24a2jgnmuot">❓ LO QUE MÁS NOS PREGUNTAN</h2>
        <div className="space-y-3" data-id="element-57" data-mp="2p4vmjlgui7o4">
          {faqs.map((f, i) => <div key={f.q} className={`rounded-xl border transition-colors ${open === i ? 'border-[#F2C14E] bg-[#04201a]' : 'border-[#F2C14E]/20 bg-[#06291f]'}`} data-id="element-58" data-mp="2u2f16mhggmgl" data-mpi={i}>
              <button className="w-full text-left px-5 py-4 flex items-center justify-between gap-3" onClick={() => setOpen(open === i ? null : i)} aria-expanded={open === i} data-id="element-59" data-mp="2z0gjv6ayyjrj">
                <span className="text-white font-bold text-sm sm:text-base" data-id="element-60" data-mp="381n4nrknigql">{f.q}</span>
                <span className={`text-[#F2C14E] text-xl flex-shrink-0 transition-transform ${open === i ? 'rotate-45' : ''}`} data-id="element-61" data-mp="3d0hjyjjetn5y">+</span>
              </button>
              {open === i && <div className="px-5 pb-5" data-id="element-62" data-mp="3mr2qqu98lxzy">
                  <div className="h-px bg-[#F2C14E]/20 mb-4" data-id="element-63" data-mp="3mqt0r6o6zqu9" />
                  <p className="text-gray-200 text-sm leading-relaxed" data-id="element-64" data-mp="3qtfu5c0ihjtk">{f.a}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}